<template>
    <div class="d-flex flex-column w-100 align-items-center gap-3">
        <h5 v-if="question.question_desc" class="text-primary text-bold m-0 fs-5 text-center text-uppercase">{{ $t('description') }}</h5>
        <div class="question-text" v-if="question.question_desc">
            <div v-html="question.question_desc"></div>
        </div>
        <h5 class="text-primary text-bold m-0 fs-5 text-center text-uppercase">{{ $t('question') }}</h5>
        <div class="question-text" v-if="question.desc">
            <div v-html="parsedQuestionDesc"></div>
        </div>
        <div class="img-wrapper img-thumbnail mt-3" v-if="question.illustration_url">
            <img ref="questionImage" class="img-fluid" :src="question.illustration_url" :alt="question.id">
            <button class="zoom-image zoom-in" @click="zoomImage(question.id, question.illustration_url)"></button>
        </div>
        <div class="img-wrapper img-thumbnail mt-3" v-if="question.image_url">
            <img ref="questionImage" class="img-fluid" :src="question.image_url" :alt="question.id">
            <button class="zoom-image zoom-in" @click="zoomImage(question.id, question.image_url)"></button>
        </div>
    </div>
</template>
<script>

export default {
    name: 'RenderQuestion',
    props: {
        question: {
            type: Object,
            required: true
        },
    },
    computed: {
        parsedQuestionDesc() {
            const text = this.question.desc;
            if (this.question.question_type !== 'gap') {
                return this.question.desc
            }
            return text.replace(/\[answer\]/g, '<i class="answers"></i>')
        }
    },

    methods: {
        zoomImage(question_id, image) {
            this.$swal({
                imageUrl: image,
                imageHeight: 'auto',
                imageWidth: '100%',
                imageAlt: question_id,
                width: 'auto',
                showCloseButton: true,
                closeButtonHtml: '<i class="ito-icon-close modal-close"></i>',
                showConfirmButton: false,
            });
        },
    }
}
</script>
<style scoped>
.question-text {
    white-space: pre-line;
}

.img-wrapper {
    width: 380px;
    position: relative;
    border: 1px solid #EEEEEE;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
}

.zoom-image {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    bottom: 5px;
    right: 5px;
    padding: 5px;
    border: 1px solid #1B1B1B;
    border-radius: 4px;
    background: #00000080;
    z-index: 1;
}

.zoom-image.zoom-in {
    content: url('data:image/svg+xml,<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.7081 11.7001C12.3841 12.0601 12.0241 12.3841 11.6641 12.6721L15.8761 16.8841L16.8841 15.8761L12.7081 11.7001ZM13.6801 7.20008C13.6801 3.81608 10.9441 1.08008 7.56006 1.08008C4.17606 1.08008 1.44006 3.81608 1.44006 7.20008C1.44006 10.5841 4.17606 13.3201 7.56006 13.3201C10.9441 13.3201 13.6801 10.5841 13.6801 7.20008ZM10.4401 7.56008H7.92006V10.0801H7.20006V7.56008H4.68006V6.84008H7.20006V4.32008H7.92006V6.84008H10.4401V7.56008Z" fill="white" /></svg>');
}

.zoom-image.zoom-out {
    content: url('data:image/svg+xml,<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.7081 11.7001C12.3841 12.0601 12.0241 12.3841 11.6641 12.6721L15.8761 16.8841L16.8841 15.8761L12.7081 11.7001ZM13.6801 7.20008C13.6801 3.81608 10.9441 1.08008 7.56006 1.08008C4.17606 1.08008 1.44006 3.81608 1.44006 7.20008C1.44006 10.5841 4.17606 13.3201 7.56006 13.3201C10.9441 13.3201 13.6801 10.5841 13.6801 7.20008ZM10.4401 7.56008H7.56008H4.68006V6.84008H10.56008Z" fill="white"/></svg>');
}
</style>